require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./introduction-to-logic-programming-with-prolog.json") })
        }
      }, "path---introduction-to-logic-programming-with-prolog");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---introduction-to-logic-programming-with-prolog!./.cache/json/introduction-to-logic-programming-with-prolog.json
// module id = 331
// module chunks = 231608221292675